// extracted by mini-css-extract-plugin
module.exports = {"block":"aed17b9412--block--KXKte","text-content":"aed17b9412--text-content--nYfre"};